import { NgModule } from '@angular/core';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { PaymentCallbackComponent } from './pages/payment-callback/payment-callback.component';
import { RouterModule, Routes } from '@angular/router';
import { RefundPageComponent } from './pages/refund-page/refund-page.component';

let routes: Routes = [
    {
        path: 'landing', component: LandingPageComponent
    },
    {
        path: 'paymentcallback', component: PaymentCallbackComponent
    },
    {
        path: 'refund', component: RefundPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

